import React from "react";

export type GeoListColumn<T> = {
  key: string;
  header: React.ReactNode;
  hideSm?: boolean;
  className?: string;
  cell: (row: T) => React.ReactNode;
};

export type GeoResponsiveListProps<T> = {
  rows: T[];
  rowKey: (row: T) => string;
  columns: GeoListColumn<T>[];
  empty: React.ReactNode;
  actions: (row: T) => React.ReactNode;
  tableClassName?: string;
};

function GeoResponsiveList<T>({
  rows,
  rowKey,
  columns,
  empty,
  actions,
  tableClassName,
}: GeoResponsiveListProps<T>) {
  const colCount = columns.length + 1;
  return (
    <div className="geo-table-wrap geo-list-table">
      <table className={tableClassName ? `geo-table ${tableClassName}` : "geo-table"}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                className={[column.className, column.hideSm ? "geo-table__hide-sm" : ""]
                  .filter(Boolean)
                  .join(" ")}
              >
                {column.header}
              </th>
            ))}
            <th className="geo-col-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={colCount} className="geo-table__empty">
                {empty}
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr key={rowKey(row)}>
                {columns.map((column) => (
                  <td
                    key={column.key}
                    data-label={typeof column.header === "string" ? column.header : undefined}
                    className={[column.className, column.hideSm ? "geo-table__hide-sm" : ""]
                      .filter(Boolean)
                      .join(" ")}
                  >
                    {column.cell(row)}
                  </td>
                ))}
                <td className="geo-col-actions">
                  <div className="geo-table__actions">{actions(row)}</div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default GeoResponsiveList;
